import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import MfaCard from "@/components/MfaCard";

export default function Profile() {
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadMe = useCallback(async () => {
    const r = await api.get("/auth/me");
    setMe(r.data.user);
  }, []);
  useEffect(() => { loadMe(); }, [loadMe]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) return toast.error("Passwords do not match");
    if (pw.new_password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: pw.current_password,
        new_password: pw.new_password,
      });
      toast.success("Password changed");
      setPw({ current_password: "", new_password: "", confirm: "" });
      if (me?.must_change_password) window.location.href = "/";
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl">
      <div className="label-mono">Profile</div>
      <h1 className="font-chivo font-black text-3xl uppercase tracking-tighter">Account settings</h1>

      {me?.must_change_password && (
        <div className="mt-4 border border-yellow-500 bg-yellow-100 p-3 text-sm" data-testid="must-change-notice">
          You must set a new password before continuing.
        </div>
      )}

      <div className="brut-card mt-6 p-6">
        <div className="text-sm space-y-1">
          <div><span className="label-mono">Name</span><div className="font-medium">{me?.name}</div></div>
          <div><span className="label-mono">Email</span><div className="font-mono text-xs">{me?.email}</div></div>
          <div><span className="label-mono">Role</span><div className="font-mono text-xs">{me?.role}</div></div>
        </div>
      </div>

      <form onSubmit={submit} className="brut-card mt-6 p-6 space-y-4">
        <div className="font-chivo font-bold uppercase tracking-tight">Change password</div>
        <div>
          <label className="label-mono">Current password</label>
          <input data-testid="cp-current" type="password" required
            className="w-full border border-black px-3 py-2 mt-1"
            value={pw.current_password}
            onChange={(e) => setPw({ ...pw, current_password: e.target.value })} />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="label-mono">New password</label>
            <input data-testid="cp-new" type="password" required
              className="w-full border border-black px-3 py-2 mt-1"
              value={pw.new_password}
              onChange={(e) => setPw({ ...pw, new_password: e.target.value })} />
          </div>
          <div>
            <label className="label-mono">Confirm</label>
            <input data-testid="cp-confirm" type="password" required
              className="w-full border border-black px-3 py-2 mt-1"
              value={pw.confirm}
              onChange={(e) => setPw({ ...pw, confirm: e.target.value })} />
          </div>
        </div>
        <button data-testid="cp-submit" disabled={loading}
          className="bg-black text-white px-4 py-2 uppercase text-xs tracking-widest font-bold hover:translate-x-[2px] hover:translate-y-[2px] hover:brut-shadow-sm transition-transform duration-100">
          {loading ? "Saving…" : "Update password"}
        </button>
      </form>

      <div className="mt-6">
        <MfaCard user={me} onChange={loadMe} />
      </div>
    </div>
  );
}
